import { Pipe, PipeTransform } from '@angular/core';

/**
 * If searchValue, replaceValue are not passed, replaceStr would replace all occurrences of space with '_'
 *
*/
@Pipe({ name: 'replaceStr' })
export class ReplaceString implements PipeTransform {
    private _searchValue = ' ';
    private _replaceValue = '_';

    transform(value: string, searchValue?: string | RegExp, replaceValue?: string): string {

        value = `${value}`;
        searchValue = searchValue || this._searchValue;
        replaceValue = replaceValue || this._replaceValue;

        return searchValue instanceof RegExp ? value.replace(new RegExp(searchValue), replaceValue)
            : value.replace(new RegExp(searchValue, 'g'), replaceValue);
    }
}
